module.exports = __webpack_public_path__ + "static/media/b1.553c69e9.jpg";